<template>
  <div v-if="approval === 'approval'" class="container">
    <el-button type="danger" @click="manageApproval('N')">{{ $t('common.reject') }}</el-button>
    <el-button type="primary" @click="manageApproval('Y')">{{ $t('common.passAll') }}</el-button>
    <el-button type="default" @click="back">{{ $t('common.cancel') }}</el-button>
  </div>
</template>

<script>
import { approval } from '@api/inquery'
import { approvalDialog, rejectDialog } from '../../config/fn'
export default {
  name: 'Approval',
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    type: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      approval: this.$route.query.approval,
      id: this.$route.query.idDetail
    }
  },
  mounted() {
    this.$parent.$parent.$el.setAttribute('style', 'background-color:#F3F5F6')
  },
  methods: {
    // 驳回  "approvalResult":"审批结果(Y,通过.N,驳回)",
    async manageApproval(Result) {
      let vm = null
      if (Result === 'Y') {
        vm = await approvalDialog.open({ attrs: { }})
      } else {
        vm = await rejectDialog.open({ attrs: { }})
      }
      const data = {
        approvalResult: Result,
        approvalOpinion: vm.data.approvalOpinion,
        processId: this.id,
        type: this.type
      }
      await approval(data)
      this.closeAndBackRoute()
    },
    back() {
      this.$router.back()
    }
  }
}
</script>

<style lang="scss" scoped>
  .container {
    width: 102%;
    background: #F3F5F6;
    padding-top: 15px;
    position: relative;
    left: -17px;
    overflow: hidden;
  }
</style>
